import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { SMALL_TEXT_PX, PRIMARY_FONT_COLOR, X_SMALL_TEXT_PX, TITLE_FONT_COLOR,
    RED_FONT_COLOR, 
    FONT_FAMILY_REGULAR, SEMANTIC_TEXT_SMALL_PX, BLACK_FONT_COLOR, GREY_PRODUCT_LIST_COLOR, LIST_VIEW_TABLE_CELL, DARK_NAVY_FONT_COLOR, GREY_COLOR, BLACK_FONT_COLOR2} from '../../../styles/fonts/MCFontConstants';
import { KeyboardArrowDown } from '@material-ui/icons';
import { KeyboardArrowUp } from '@material-ui/icons';
import { Add } from '@material-ui/icons';
import { Remove } from '@material-ui/icons';

export const ItemListViewWrapper = styled.div.attrs(
    props => ({ id: props.id || 'item-list-view-wrapper' })
)`
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0.5%'};
    width: ${({ width }) => width && width};
    padding: ${({ desktopPading }) => desktopPading && desktopPading};
    ${media.mobileDevice`
    padding: ${({ padding }) => padding && padding};
`}
`;

export const NoMatchError=styled.div`
    color:${RED_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    opacity: 0.7;
    font-size: ${X_SMALL_TEXT_PX};
    margin-top: 2px;
`;

export const ItemTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: 'AvenirNextWorld demi';
    font-size: ${SMALL_TEXT_PX};
    border-bottom: ${({ borderBottom }) =>
        borderBottom ? borderBottom : '1px solid #ddd'};
    table-layout: fixed;
`;

export const TableHeaderContainer = styled.thead`
    position: ${({ position }) => (position ? position : 'static')};
    z-index: ${({ zIndex }) => (zIndex)};
    top: ${({ top }) => (top)};
    height: ${({ height }) => (height)};
    font-family: 'AvenirNextWorld demi';
`;


export const CheckBoxContainer = styled.div`
    padding-top: -2px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-left: -51px;


    @media (min-width: 1024px) and (max-width: 1366px) {
        margin-left: ${({ isAddToBundle }) =>  
            isAddToBundle ? '0px' : '-51px'
        };
    }
`;

export const TableHeader = styled.th`
    background-color: ${({ isSubItem }) => (isSubItem ? GREY_PRODUCT_LIST_COLOR : 'white')};
    color: ${PRIMARY_FONT_COLOR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : X_SMALL_TEXT_PX )};
    width: ${({ width }) => width && width};
    font-weight: bold;
    padding: ${({ isForProductGuide,isForSetItem }) => ((isForProductGuide || isForSetItem ) ? '7px 0px' : '7px 10px')};
    text-align: left;
    padding-left: ${({ isSubItem, paddingLeft }) =>
        paddingLeft && isSubItem && '2.5%'};
    border-bottom: 1px solid #ddd;
    white-space: nowrap;

    &.quantity {
        text-align: center;
    }
    &.uom-wrapper {
        text-align: ${({ textAlign }) => textAlign || 'center'};
        padding: ${({ padding }) => padding || '7px 10px'};
        // ${media.ipadAir`
        //     padding: 7px 35px;
        // `}
    }
    &.uom {
        text-align: center;
    }
    &.quantityUoM {
        text-align: center;
    }
    &.extPrice{
        text-align: right;
    }
    &.batch {
        text-align: left;
    }
    &.checkBox {
        width: 11%;
    }
    ${media.mediumDevice`
    &.quantity {
        padding-right: 5px;
    }
`}
@media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){     
padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '')};
padding-left:${({ ipadPaddingLeft }) => (ipadPaddingLeft ? ipadPaddingLeft : '')};
}
${media.ipadAir` 
      padding: ${({ ipadAirPadding }) => (ipadAirPadding ? ipadAirPadding : '')}; 
      padding-left:${({ ipadAirPaddingLeft }) => (ipadAirPaddingLeft ? ipadAirPaddingLeft : '')};
    `}
`;

export const TableData = styled.td`
    padding: ${({ isSubItem, padding }) =>
        isSubItem ? '8px 8px 8px 2.5%' : padding ? padding : '8px 8px'};
    font-family: 'AvenirNextWorld Regular';
    font-size: ${({ isReviewSubmitScreenEquity }) =>
        isReviewSubmitScreenEquity ? SEMANTIC_TEXT_SMALL_PX : SMALL_TEXT_PX};
    width: ${({ width }) => width && width};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};

    &.quantity {
        text-align: ${({ alignLeft }) => (alignLeft ? 'left' : 'right')};
        font-weight: 400;
    }
    &.uom {
        text-align: center;
    }
    &.price {
        text-align: ${({ alignLeft }) => (alignLeft ? 'left' : 'right')};
        padding-right: 10px;
    }

    &.delete {
        text-align: center;
        padding-left: ${({ paddingDelete }) =>
            paddingDelete ? paddingDelete : '4%'};
    }

    &.description {
        // display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        // padding-left : ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '10px')};
        padding-left: ${({ isForProductGuide, paddingLeft, isFromSetItemDetailsLists }) =>
            isForProductGuide ? '0px' : isFromSetItemDetailsLists ? '0px' :(paddingLeft ? paddingLeft : '10px')};
    }

    &.product {
        color: ${TITLE_FONT_COLOR};
        //font-weight: bold;
        font-family: 'AvenirNextWorld demi';
        //cursor: pointer;
    }
    &.quantityUoM {
        text-align: center;
    }
    &.dropdown {
        padding-right: 38px;
    }
    &.batch {
        padding: 0px 0px;
        height: 45px;
    }
        @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){     
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '')};
        padding-left:${({ ipadPaddingLeft }) => (ipadPaddingLeft ? ipadPaddingLeft : '')};
        }
        ${media.ipadAir` 
              padding: ${({ ipadAirPadding }) => (ipadAirPadding ? ipadAirPadding : '')}; 
              padding-left:${({ ipadAirPaddingLeft }) => (ipadAirPaddingLeft ? ipadAirPaddingLeft : '')};
            `}
`;
export const clickHandle = styled.td`
    cursor: pointer;
`;
export const TableRow = styled.tr`
    background-color: ${({ index, isSubItem, parentIndex }) =>
        isSubItem
            ? parentIndex % 2 === 0
                ? 'white'
                : GREY_PRODUCT_LIST_COLOR
            : index % 2 === 0
            ? 'white'
            : GREY_PRODUCT_LIST_COLOR};
    // &:nth-child(even) {
    //     background-color: GREY_PRODUCT_LIST_COLOR;
    // }

    // &:nth-child(odd) {
    //     background-color: white;
    // }

    // &:hover {
    //   background-color: #e0e0e0;
    // }
`;

export const ProductCfn = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    font-weight: 600;
    line-height: 31.28px;
    color: ${TITLE_FONT_COLOR};
`;

export const ProductData = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
`;

export const Quantity = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    font-weight: 400;
    line-height: 27.81px;
    color: ${BLACK_FONT_COLOR2};
`;

export const ProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 4% 10px 4%;
    border-top: ${({ borderTop }) => borderTop && borderTop};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
    &:nth-child(even) {
        background-color: ${GREY_PRODUCT_LIST_COLOR};
    }

    &:nth-child(odd) {
        background-color: white;
    }
`;

export const TypeText = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 43%;
    display: inline;
    padding-left: 9px;
    padding-right: 9px;
    margin-left: 5px;
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    text-align: center;
`;

export const Description = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-weight: 400;
    line-height: 22.59px;
    color: ${LIST_VIEW_TABLE_CELL};
`;

export const Brands = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-weight: 700;
    line-height: 22.59px;
    color: ${LIST_VIEW_TABLE_CELL};
`;

export const BrandsName = styled.div`
    display: block;
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-weight: 400;
    line-height: 22.59px;
    color: ${LIST_VIEW_TABLE_CELL};
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    width: ${({ $width }) => $width || '22px'};
    height: ${({ $height }) => $height || '22px'};
    border: 1px solid;
    border-radius: 50%;
    justify-content: center;
    color: ${GREY_COLOR};
    margin-left: 2.5%;
`;

export const ErrorTableRow = styled.tr`
    background-color: ${({ index }) =>
        index % 2 === 0 ? 'white' : GREY_PRODUCT_LIST_COLOR};
    // &:nth-child(even) {
    //     background-color: ${GREY_PRODUCT_LIST_COLOR};
    // }

    // &:nth-child(odd) {
    //     background-color: white;
    // }
`;

export const InputBox = styled.input.attrs(() => ({
    enterKeyHint: 'go',
}))`
    font-family: 'AvenirNextWorld Regular';
    border: ${({ border }) => (border ? border : '2px solid #ececec')};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    text-align: center;
    margin: auto 3px;
    border-radius: 4px;
    color: ${BLACK_FONT_COLOR};
    opacity: 1;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    height: ${({ height }) => (height ? height : '35px')};
    width: ${({ width }) => (width ? width : '35px')};
    background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : 'transparent'};
`;

export const CheckMarkImg = styled.img`
    width: 31px;
    height: 31px;
    object-fit: contain;
`;

export const DownArrow = styled(KeyboardArrowDown)`
    width: 30px !important;
    height: 25px !important;
    color: ${TITLE_FONT_COLOR};
    margin-bottom: -7%;
    cursor: pointer;
`;

export const UpArrow = styled(KeyboardArrowUp)`
    width: 30px !important;
    height: 25px !important;
    color: ${TITLE_FONT_COLOR};
    margin-bottom: -7%;
    cursor: pointer;
`;

export const AddIcon = styled(Add)`
    width: 19px;
    height: 19px;
    font-size: 14px !important;
    color: #1010eb !important;
`;

export const RemoveIcon = styled(Remove)`
    width: 19px;
    height: 19px;
    color: #1010eb !important;
    font-size: 14px !important;
`;